import gql from 'graphql-tag';

export const CREATE_DEFAULT_AUTOMATION_MESSAGE_TEMPLATES = gql`
  mutation CreateDefaultAutomationMessageTemplates {
    messageTemplates: createDefaultAutomationMessageTemplates {
      id
    }
  }
`;
